import type { DeepPartial } from '@luna/utils-ts';

import type { Orders } from '../../types/Orders';

export const ordersSKFeatureConfig: DeepPartial<Orders> = {
    showExtendedDetailsView: true,
    showFeesPriceNote: true,
    showOpenOrders: true,
    showPortfolioDropdown: true,
    showStatement: true,
    typesNotToShowISIN: ['COMMODITY'],
    typesToShowCouponInfo: ['BOND', 'CERTIFICATE', 'WARRANT'],
    typesToShowSubType: ['BOND', 'FUND', 'CERTIFICATE'],
};
